function menuItem(key) {
  const { id, name } = this.supportedLanguages[key] || {};

  return `
  <li class="c-menu__item">
    <button
        class="c-button c-menu__trigger"
        lang="${id}">
          ${name}
    </button>
  </li>`.trim();
}

function codeBlockMenu(string) {
  return `
  <div class="code-window-menu">
    <menu type="toolbar"
        class="c-menu c-menu--horizontal c-menu--code">
        ${string}
    </menu>
  </div>`.trim();
}

function groupNote(visible = false) {
  return `
  <li
    class="code-window-menu-note"
    style="display: ${visible ? 'block' : 'none'}">
      <small>
        No <span class="toolbar-mode"></span> example exists
      </small>
  </li>`.trim();
}

export default {
  menuItem,
  codeBlockMenu,
  groupNote,
};
